import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Outlet } from "react-router-dom";
import "./App.scss";
import { Footer } from "./components/Footer/Footer";
import { Header } from "./components/Header/Header";
import { Main } from "./components/Main/Main";
import { About } from "./components/About/About";
import { Books } from "./components/Books/Books";
import { Research } from "./components/Research/Research";
import { Grants } from "./components/Grants/Grants";
import { Publications } from "./components/Publications/Publications";
import { Articles } from "./components/Articles/Articles";
import { Chapters } from "./components/Chapters/Chapters";
import { Teaching } from "./components/Teaching/Teaching";
import { ProfessionalEngagement } from "./components/ProfessionalEngagement/ProfessionalEngagement";
import { GuestLectures } from "./components/ProfessionalEngagement/GuestLectures/GuestLectures";
import { Consulting } from "./components/ProfessionalEngagement/Consulting/Consulting";
import { Workshop } from "./components/ProfessionalEngagement/Workshop/Workshop";
import { Services } from "./components/ProfessionalEngagement/Service/Services";
import { CV } from "./components/CV/CV";
import { Awards } from "./components/Awards/Awards";
import { Contacts } from "./components/Contacts/Contacts";
import { MobileMenu } from "./components/MobileMenu/ MobileMenu";
import { NotFound } from "./components/NotFound/NotFound";
import { Boards } from "./components/ProfessionalEngagement/Boards/Boards";

const Layout = () => (
	<div className="page">
		<MobileMenu />
		<Header />
		<Main>
			<Outlet /> {/* This renders the matched child route */}
		</Main>
		<Footer />
	</div>
);

const router = createBrowserRouter([
	{
		path: "/", // This is the parent route
		element: <Layout />,
		children: [
			{
				index: true, // This makes <About/> render at the root path "/"
				element: <About />,
			},
			{ path: "books", element: <Books /> }, // No leading slash in child paths
			{
				path: "research",
				element: <Research />,
				children: [
					{
						path: "grants",
						element: <Grants />,
					},
					{
						path: "publications",
						element: <Publications />,
						children: [
							{
								path: "articles",
								element: <Articles />,
							},
							{
								path: "chapters",
								element: <Chapters />,
							},
							{ path: "*", element: <NotFound /> },
						],
					},
					{ path: "*", element: <NotFound /> },
				],
			},
			{ path: "teaching", element: <Teaching /> },

			{
				path: "professionalEngagement",
				element: <ProfessionalEngagement />,
				children: [
					{
						path: "guestLectures",
						element: <GuestLectures />,
					},
					{
						path: "consulting",
						element: <Consulting />,
					},
					{
						path: "workshop",
						element: <Workshop />,
					},
					{
						path: "services",
						element: <Services />,
					},
					{
						path: "editorialBoards",
						element: <Boards />,
					},
					{ path: "*", element: <NotFound /> },
				],
			},
			{ path: "cv", element: <CV /> },
			{ path: "awards", element: <Awards /> },
			{ path: "contacts", element: <Contacts /> },
			{ path: "*", element: <NotFound /> },
		],
	},
]);

export const App = () => {
	return <RouterProvider router={router} />;
};
